<template>
  <ArtworkHistoryModal
    v-if="showModal"
    :index="index"
    :single-selection-mode="singleSelectionMode"
    :reorder-enabled="reorderEnabled"
    is-made
    @close="handleClose"
  />
</template>

<script setup>
import { computed, defineProps, onMounted, onUnmounted, ref, watch } from "vue";
import ArtworkHistoryModal from "components/jiffy/vue-product-details-dtf/ArtworkHistoryModal.vue";
import DesignUploadCtaPlpPreviewClass from "components/jiffy/design-upload-cta/design-upload-cta-plp/design-upload-cta-plp-preview-class";
import DesignUploadCtaPlpCookieClass from "components/jiffy/design-upload-cta/design-upload-cta-plp/design-upload-cta-plp-cookie-class";
import { EventBus, Events } from "jiffy-store";
import { useDtfStore } from "../vue-product-details-dtf/store";

defineProps({
  index: { type: Number, default: 0 },
  singleSelectionMode: { type: Boolean, default: false },
  reorderEnabled: { type: Boolean, default: false }
});

const selectedArtwork = ref(null);

const state = useDtfStore();

const showModal = computed(() => state.showArtworkHistoryModal);

const artworkHistory = computed(() => state.artworkHistory);

const isNonPdp = computed(() => state.pdpType === "non-pdp");

const handleOpen = async () => {
  state.setShowArtworkHistoryModal(true);
};

const handleClose = () => {
  state.setShowArtworkHistoryModal(false);
};

const handleSelectArtwork = artwork => {
  selectedArtwork.value = artwork;
  if (isNonPdp.value) {
    DesignUploadCtaPlpCookieClass.cookie = {
      url: artwork.ordered.imageUrl,
      id: artwork.id,
      original_image_url: artwork.original.imageUrl,
      original_mime: artwork.original.mimeType,
      updated_at: new Date().toISOString()
    };
    new DesignUploadCtaPlpPreviewClass({ url: artwork.ordered.imageUrl }).show();
  }
};

onMounted(() => {
  EventBus.on(Events.DESIGN_LIBRARY_MODAL_OPEN, handleOpen);
});

onUnmounted(() => {
  EventBus.removeEventListener(Events.DESIGN_LIBRARY_MODAL_OPEN, handleOpen);
});

watch(artworkHistory, newVal => {
  if (newVal.length === 1) {
    handleSelectArtwork(newVal[0]);
  }
});

defineExpose({ open: handleOpen, close: handleClose, selectedArtwork });
</script>
